import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const SotyBadge = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
